import _ from 'lodash';
import { handleActions, combineActions } from 'redux-actions';
import actions from '../actions';

const { add, edit, remove, reset, toggle, recover } = actions.cart;

const defaultState = {
  active: false,
  items: {},
};

const cart = handleActions(
  {
    [combineActions(add, edit)]: (state, { payload }) => {
      const { items, ...cartProps } = state;
      const { item, editMode } = payload;
      const {
        retail_price,
        quantity = 1,
        productId,
        id,
        discount: inputDiscount,
        ...itemProps
      } = item;
      const itemInCart = _.get(items, [id], {});
      const quantityInCart = _.get(itemInCart, ['quantity'], 0);
      const discountInCart = _.get(itemInCart, ['discount'], {});
      const newItems = {
        ...items,
        [id]: {
          productId,
          retail_price,
          quantity: editMode ? quantity : quantityInCart + quantity,
          discount:
            _.size(inputDiscount) > 0 || editMode
              ? inputDiscount
              : discountInCart,
          ...itemProps,
        },
      };

      return {
        items: newItems,
        ...cartProps,
      };
    },
    [recover]: (state, { payload }) => ({ ...state, items: payload.items }),
    [remove]: (state, { payload }) => {
      const { items, ...cartProps } = state;

      return {
        items: _.omit(items, [payload.id]),
        ...cartProps,
      };
    },
    [reset]: () => defaultState,
    [toggle]: state => ({ ...state, active: !state.active }),
  },
  defaultState
);

export default cart;



// WEBPACK FOOTER //
// ./src/reducers/cart.js